import { Grid, Typography } from "@mui/material";
import { ROUTES } from "@/utils/navigation";
import useResponsive from "@/hooks/useResponsive";

import InterestedCard from "@/components/AboutUs/InterestedIn/InterestedCard";
import Section from "@/components/Section";
import BecomeDealerShowcase from "./InterestedShowcase/BecomeDealerShowcase";
import InquiriesShowcase from "./InterestedShowcase/InquiriesShowcase";

const InterestedIn = () => {
  const isMobile = useResponsive("down", "md");

  return (
    <Section pt={{ xs: 5, md: 6, lg: 12.5 }} pb={{ xs: 10, md: 6, lg: 17.5 }}>
      <Typography
        variant="h2"
        mb={{ xs: 5, md: 8, lg: 10 }}
        maxWidth={{ xs: "80%", md: "100%" }}
        textAlign={{ xs: "start", md: "center" }}
      >
        You may also be interested in..
      </Typography>

      <Grid container spacing={{ xs: 4, lg: 2, xl: 4 }}>
        <Grid item xs={12} lg={6}>
          <InterestedCard
            title="Become an installer"
            subtitle="Explore partnership opportunities with Trackmate"
            path={ROUTES.becomeDealer}
          >
            <BecomeDealerShowcase />
          </InterestedCard>
        </Grid>

        <Grid item xs={12} lg={6}>
          <InterestedCard
            title={isMobile ? "Resources" : "Fleet inquiries"}
            subtitle="Test drive the future with Trackmate fleet solutions"
            path={ROUTES.fleetInquiry}
          >
            <InquiriesShowcase />
          </InterestedCard>
        </Grid>
      </Grid>
    </Section>
  );
};

export default InterestedIn;
